// extracted by mini-css-extract-plugin
module.exports = {"checkBoxContainer":"CheckBox__checkBoxContainer","isChecked":"CheckBox__isChecked","checkBox":"CheckBox__checkBox"};